<style scoped lang="scss">
@import '~variables';
.btn {
    margin-left: 0 !important;
    white-space: nowrap;
}
</style>

<template>
    <div>
        <button type="button" @click="confirm()" class="btn btn-link m-1">
            <slot></slot>
            <span class="fas fa-trash mr-1"></span>
        </button>
        <modal @initized="modal = $event"></modal>
    </div>
</template>

<script>
    export default {

        props: {
            search: Object,
            href: String,
            item: String,
        },

        data() {
            return {
                modal: undefined,
            }
        },

        methods: {

            confirm() {

                this.modal
                .title(this.trans.get('general.delete_warning_title'))
                .message(this.trans.get('general.delete_warning_message', {name: this.item}))
                .confirm((confirmed) => {
                    if (confirmed) {

                        this.$root.pageSpinner.spin(axios.delete(this.href))
                        .then(response => {
                            this.search.search();
                            this.$toasted.global.appSuccess({
                                message : this.trans.get('general.delete_success')
                            });
                        })
                        .catch(error => {
                            this.$toasted.global.appError({
                                message : this.trans.get('general.delete_error') + error
                            });
                        });
                    }
                });

            },

        }
    }
</script>
